import React from 'react';

const ServiceCard = ({ icon: Icon, title, isSelected, onClick }) => {
  return (
    <div 
      onClick={onClick}
      className={`
        cursor-pointer rounded-xl p-6 transition-all duration-300 flex flex-col items-center justify-center gap-4
        border-2 shadow-sm hover:shadow-lg h-40 group
        ${isSelected 
          ? 'border-brand-accent bg-brand-primary text-brand-accent shadow-brand-accent/20' 
          : 'border-brand-primary bg-brand-secondary text-white hover:border-brand-accent hover:text-brand-accent'
        }
      `}
    >
      <Icon className={`w-10 h-10 transition-colors duration-300 ${isSelected ? 'text-brand-accent' : 'text-white group-hover:text-brand-accent'}`} />
      <span className="font-semibold text-center">{title}</span>
    </div>
  );
};

export default ServiceCard;
